// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"27819c28","196":"96e2482a","304":"7d848c1a","408":"c2f2802b","617":"b34d923e","843":"ddaa9c49","882":"a6d9fa04"}[chunkId] + ".chunk.js";
};